import { render, staticRenderFns } from "./LotTemplateEditInfo.vue?vue&type=template&id=bdddca34&"
import script from "./LotTemplateEditInfo.vue?vue&type=script&lang=js&"
export * from "./LotTemplateEditInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports